import type { Flashcard } from '../db/schema'

const DAY_MS = 24 * 60 * 60 * 1000
const MIN_TTA_SECONDS = 5

const difficultyBase = {
  low: 4,
  medium: 2,
  high: 1.65,
} as const

const graduationStage = {
  low: 4,
  medium: 6,
  high: 9,
} as const

export function scheduleFlashcardReview(args: {
  flashcard: Flashcard
  mark: number
  ttaSeconds: number
  now?: Date
}) {
  const now = args.now ?? new Date()
  const next = { ...args.flashcard }
  const difficulty = next.difficulty as keyof typeof difficultyBase
  const nextTtaSeconds = Math.max(Math.round(args.ttaSeconds), MIN_TTA_SECONDS)

  next.ttaSeconds =
    args.flashcard.repeatAt === 'now'
      ? Math.min(nextTtaSeconds, Math.max(next.ttaSeconds, MIN_TTA_SECONDS))
      : Math.max(
          Math.round((nextTtaSeconds + next.ttaSeconds) / 2),
          MIN_TTA_SECONDS,
        )

  if (args.mark < 1) {
    if (next.importance === 'low') next.stage += 1
    else if (next.importance === 'high') next.stage = 0
    else next.stage = Math.max(next.stage - 1, 0)
  } else {
    next.stage += 1
  }

  const reviewInDays = Math.max(
    Math.min(Math.floor(difficultyBase[difficulty] ** next.stage), 128),
    1,
  )
  const repeatAt = new Date(now.getTime() + reviewInDays * DAY_MS)
  next.repeatAt = repeatAt
  next.updatedAt = now

  return {
    next: { ...next, repeatAt },
    reviewInDays,
    graduated: next.stage >= graduationStage[difficulty],
  }
}
